import io from 'socket.io-client';
import Cookies from 'js-cookie';
import { baseURL } from './baseService';

const socket = io(baseURL, {
  autoConnect: false,
});

// Attach the current auth token to the handshake, then connect.
export const connectSocketWithAuth = () => {
  const token = Cookies.get('chocolateChip');
  if (!token) return;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (socket as any).io.opts.query = `token=${encodeURIComponent(token)}`;
  socket.connect();
};

export const handleEmitError = (result) => {
  if (!result.success) {
    console.error(result.error);
  }
};

export default socket;
